<div class="pageheader">
  <div class="page-title">
    <h1>Batching Configurations</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Batching configurations log'">
        <app-change-log-link-entity type="BatchingConfiguration" [id]="''"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='batchingConfigurations' [bizHideSelectedRowsComponent]="true" [showResetButton]="true"
  (onInitNewRow)="onInitNewRow($event)" (onRowInserted)="onRowInserted($event)" (onRowUpdating)="onRowUpdated($event)" (onRowRemoving)="onRowRemoving($event)"
  [bizEditRowOnDoubleClick]="true" (onRowValidating)="onRowValidating($event)" (onEditCanceled)="onEditCanceled($event)">

  <dxo-editing mode="popup" [allowAdding]="hasCreatePerm" [allowUpdating]="hasEditPerm" [allowDeleting]="hasDeletePerm">
    <dxo-popup title="Batching configuration edit" [showTitle]="true"></dxo-popup>

    <dxo-form>
      <dxi-item dataField="Name" [colSpan]="1"></dxi-item>
      <dxi-item dataField="NoOfDocuments" [colSpan]="1"></dxi-item>
      <dxi-item dataField="MinutesSinceFirstDocument" [colSpan]="1"></dxi-item>
      <dxi-item dataField="MinutesSinceLatestDocument" [colSpan]="1"></dxi-item>
      <dxi-item dataField="BatchingKey" [colSpan]="2"></dxi-item>
      <dxi-item dataField="DocumentType" [colSpan]="2" editCellTemplate="singleDropDownBoxEditor"></dxi-item>
      <dxi-item dataField="ScheduleItem" [colSpan]="2" editCellTemplate="editSchedule"></dxi-item>
    </dxo-form>
  </dxo-editing>


  <dxi-column dataField="Name" width="200" caption="Name" dataType="string" [allowGrouping]="false" sortOrder="asc">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="NoOfDocuments" width="180" caption="Number of documents" dataType="number" [allowGrouping]="false">
    <dxi-validation-rule type="required" />
    <dxi-validation-rule type="range" [min]="1" message="Number of documents must be greater than zero."></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="MinutesSinceFirstDocument" width="130" caption="Time since first" dataType="number" [allowGrouping]="false"></dxi-column>
  <dxi-column dataField="MinutesSinceLatestDocument" width="140" caption="Time since latest" dataType="number" [allowGrouping]="false"></dxi-column>
  <dxi-column dataField="DocumentType" width="250" caption="Document Type" dataType="string" [allowGrouping]="false" [customizeText]="displayExprDocumentType"
    editCellTemplate="singleDropDownBoxEditor">
  </dxi-column>
  <dxi-column dataField="ScheduleItem" caption="Schedule" width="350" dataType="string" [allowGrouping]="false" [customizeText]="displayExprSchedule"
  editCellTemplate="editSchedule"></dxi-column>
  <dxi-column dataField="BatchingKey" caption="Batching Key" dataType="string" [allowGrouping]="false"></dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.batchingConfigurations, 'CreatedBy'))"></dxo-header-filter></dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.batchingConfigurations, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

  <dxi-column type="buttons" alignment="right">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button text="Show Log" template="logTemplate" [visible]="hasShowLogPerm">
    </dxi-button>
  </dxi-column>



  <div *dxTemplate="let cellInfo of 'singleDropDownBoxEditor'">
    <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="docTypes" [(value)]="cellInfo.value" displayExpr="Name" valueExpr="Id"
      contentTemplate="contentTemplate">
      <div *dxTemplate="let e of 'contentTemplate'">
        <dx-data-grid [dataSource]="docTypes" [remoteOperations]="true" [height]="250" [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true"
          [focusedRowKey]="cellInfo.value" [hoverStateEnabled]="true" keyExpr="Id"
          (onSelectionChanged)="onSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">
          <dxi-column dataField="Name" sortOrder="asc"></dxi-column>
          <dxi-column dataField="Description"></dxi-column>
          <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
          <dxo-scrolling mode="virtual"></dxo-scrolling>
          <dxo-selection mode="single"></dxo-selection>
        </dx-data-grid>
      </div>
    </dx-drop-down-box>
  </div>

  <div *dxTemplate="let cellInfo of 'editSchedule'">
    <ep-schedule-item #scheduleTemplate [hideTriggerEnd]="true" [readonly]="false" [showDates]="false" [requireWeekdaySelection]="true" [scheduleItem]="$safeNavigationMigration(cellInfo.data?.ScheduleItem)"
      (scheduleItemChange)="scheduleItemChange($event, cellInfo)">
    </ep-schedule-item>
    <div>Add triggers to release batch at specific times</div>

    @if (cellInfo?.data.ScheduleItem?.Triggers?.length > 0) {
      <hr />
    }

    <ep-datafield-group-container #dfgc [formValidationGroup]="dataFieldsFormGroup" [showError]="true" [datafieldGroups]="dataFieldGroups"
      [isAlwaysEditable]="true" [numberOfColumns]="2">
    </ep-datafield-group-container>
  </div>

  <ng-container *dxTemplate="let cell of 'logTemplate'">
    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log'" [showIcon]="false" classNames="dx-link">
      <app-change-log-link-entity type="BatchingConfiguration" [id]="cell.data.Id"></app-change-log-link-entity>
      <app-change-log-link-entity type="ScheduledItem" [id]="$safeNavigationMigration(cell.data?.ScheduleItem?.Id)"></app-change-log-link-entity>
    </app-change-log-link>
  </ng-container>

</dx-data-grid>
